<template>
    <div
        :class="{ inactive }"
        class="kgr-postfix kgr-postfix--gutters kgr-postfix--center kgr-row kgr-row--smallMargin"
    >
        <div class="kgr-postfix__fixed">
            <a :href="memberUrl">
                <kgr-profile-image
                    :src="memberAvatarUrl"
                    :alt="member.fullName()"
                    size="S"
                />
            </a>
        </div>
        <div class="kgr-postfix__fluid profile">
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--smallGutters">
                <div class="kgr-postfix__fixed">
                    <div class="kgr-text kgr-text--bold">
                        <a :href="memberUrl">
                            {{ member.fullName() }}
                        </a>
                    </div>
                </div>
                <div class="kgr-postfix__fixed">
                    <kgr-member-contract-state-icon
                        :state="member.contractState"
                        class="icon"
                    />
                </div>
                <div class="kgr-postfix__fixed svg">
                    <kgr-member-dunning-icon v-if="member.isDunningActive" />
                </div>
            </div>

            <kgr-member-address :member="member" />
            <div v-if="member.dateOfBirth">
                {{ member.dateOfBirth }} ({{ formattedBirthday }})
            </div>
            <div v-if="member.membershipNumber">
                {{ $t('Mitgliedsnummer:') }}
                {{ member.membershipNumber }}
            </div>
        </div>
    </div>
</template>

<script>
import KgrMemberContractStateIcon from '../MemberContractStateIcon.vue';
import MemberAddress from '../MemberAddress';
import MemberDunningIcon from '../MemberDunningIcon';
import { MemberShortProfileMember } from '../../../js/dto/MemberShortProfile';
import ProfileImage from '../../common/ProfileImage';
import UrlMixin from '../UrlMixin';
import moment from 'moment';

export default {
    name: 'KgrMemberRelation',
    components: {
        KgrMemberContractStateIcon,
        'kgr-member-dunning-icon': MemberDunningIcon,
        'kgr-member-address': MemberAddress,
        'kgr-profile-image': ProfileImage,
    },
    mixins: [UrlMixin],
    props: {
        member: {
            type: MemberShortProfileMember,
            required: true,
        },
    },
    computed: {
        memberAvatarUrl() {
            return this.avatarUrl(this.member.id, this.member.hasAvatar, this.member.gender, this.member.avatarFileName);
        },
        memberUrl() {
            return this.urlForMember(this.member.id);
        },
        inactive() {
            return this.member.contractState.status === 0;
        },
        formattedBirthday() {
            const years = moment().diff(moment(this.member.dateOfBirth, 'DD.MM.YYYY'), 'years');

            return this.$t('{years} Jahre', { years });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .inactive {
    & kgr-profile-image {
        opacity: 0.5;
    }
    & .profile {
        color: #a1a1a1;
    }
}
.svg {
    position: relative;
    top: 1px;
}
</style>
